import { render } from "./UserContacts.vue?vue&type=template&id=42faa4bc&scoped=true"
import script from "./UserContacts.vue?vue&type=script&lang=js"
export * from "./UserContacts.vue?vue&type=script&lang=js"

import "./UserContacts.vue?vue&type=style&index=0&id=42faa4bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42faa4bc"]])

export default __exports__